var interpolateParams = require('./lib/interpolateParams');
var interpolateParamsInFirstMatch = require('./lib/interpolateParamsInFirstMatch');

module.exports = {
  interpolateParams: interpolateParams,
  interpolateParamsInFirstMatch: interpolateParamsInFirstMatch
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/interpolate-params/index.js
 ** module id = 546
 ** module chunks = 0
 **/